import Vue from "vue";
import Vuex from "vuex";

//........................................ UI Modules.....................................................
import alert from "./modules/ui/alert";
import loading from "./modules/ui/loading";
import notification from "./modules/ui/notification";
import sidebar from "./modules/ui/sidebar";
import lookups from "./modules/lookups";
import security from "./modules/security";
import dashboard from './modules/dashboard';
import workDaysClosing from './modules/workDaysClosing';
//........................................  patients OP.....................................................
import patients from './modules/patients';
import patientsProcedures from './modules/patientsProcedures';
import appointments from './modules/appointments';
import treasury from './modules/treasury';
import invoices from './modules/invoices';
import invoicesAnalysis from './modules/invoicesAnalysis';
import doctorsAppointments from './modules/doctorsAppointments';
import paymentAccounts from './modules/paymentAccounts';
//........................................  Setting .....................................................
import departments from './modules/departments';
import reasons from './modules/reviewsReasons';
import doctors from './modules/doctors';
import instructions from './modules/instructions';
import services from './modules/services';
import users from './modules/users';
import specializations from './modules/specializations';
import employees from './modules/employees';
import analysis from './modules/analysis';
//........................................  inventory Management .....................................................
import medicines from './modules/medicines';
import inventory from './modules/inventory';
import purchaseOrders from './modules/purchaseOrders';
import suppliers from './modules/suppliers';
import stockTransfers from './modules/stockTransfers';
import dispenseRequests from './modules/dispenseRequests';
import doctorPrescriptions from './modules/doctorPrescriptions';
import pharmacy from './modules/pharmacy';
import salaryDoctorsReport from './modules/salaryDoctorsReport';
import bookPatients from './modules/bookPatients.js';
import doctorsStock from './modules/doctorsStock.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // UI Modules
    alert,
    loading,
    notification,
    sidebar,
    security,
    lookups,
    dashboard,
    workDaysClosing,
    //..  patients OP ..//
    
    patients,
    patientsProcedures,
    appointments,
    treasury,
    invoices,
    invoicesAnalysis,
    doctorsAppointments,
    paymentAccounts,
    //..  setting  ..//
    users,
    reasons,
    departments,
    doctors,
    employees,
    instructions,
    services,
    analysis,
    specializations,
    //..  inventory Management ...............

    medicines,
    purchaseOrders,
    inventory,
    stockTransfers,
    suppliers,
    dispenseRequests,
    pharmacy,
    doctorPrescriptions,
    salaryDoctorsReport,
    bookPatients,
    doctorsStock,
  },
});
